import { createSlice } from '@reduxjs/toolkit'

import i18n from 'i18n'
import { LanguageCode } from 'meta/app/translate'
import { initialState } from 'store/pages/performer/state'

import { getPerformerKey } from '../_utils'
import { fetchMetadata } from '../actions/fetchMetadata'
import { getActiveEvents } from '../actions/getActiveEvents'
import { getActiveTypeticketcollections } from '../actions/getActiveTypeticketcollections'
import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'

export const PerformerSlice = createSlice({
  name: 'performer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const code = action.meta.arg.code
      const data = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getPerformerKey({ id: code, language })

      state[path] = { ...state[path], details: data }
    })

    builder.addCase(getBulkData.fulfilled, (state, action) => {
      const data = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it

      data.forEach((performer) => {
        const path = getPerformerKey({ id: performer.code, language })
        state[path] = { ...state[path], details: performer }
      })
    })

    builder.addCase(getActiveEvents.fulfilled, (state, action) => {
      const { code, data, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getPerformerKey({ id: code, language })

      state[path] = {
        ...state[path],
        activeEvents: {
          data: {
            ...state[path]?.activeEvents?.data,
            [metadata.page]: data,
          },
          metadata,
        },
      }
    })
    builder.addCase(getActiveTypeticketcollections.fulfilled, (state, action) => {
      const { code, data, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getPerformerKey({ id: code, language })

      state[path] = {
        ...state[path],
        activeTypeticketcollections: {
          data: {
            ...state[path]?.activeTypeticketcollections?.data,
            [metadata.page]: data,
          },
          metadata,
        },
      }
    })

    builder.addCase(fetchMetadata.fulfilled, (state, action) => {
      const { id, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getPerformerKey({ id, language })

      state[path] = { ...state[path], metadata }
    })
  },
})
